import React, { useState, useEffect } from 'react';
import { pagesData } from '../data/pagesData';
import HeroSection from '../components/sections/HeroSection';
import VisionMissionSection from '../components/sections/VisionMissionSection';
import AboutPreview from '../components/sections/AboutPreview';
import ServicesSection from '../components/sections/ServicesSection';
import ServicesGridSection from '../components/sections/ServicesGridSection';
import ServicesCTASection from '../components/sections/ServicesCTASection';
import ProjectsSection from '../components/sections/ProjectsSection';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import NewsSection from '../components/sections/NewsSection';
import ContactCallout from '../components/sections/ContactCallout';
import MapSection from '../components/sections/MapSection';
import ImpactSection from '../components/sections/ImpactSection';


type PageProps = { language: 'ar' | 'en' };

const Home: React.FC<PageProps> = ({ language }) => {
  const [sections, setSections] = useState<any[]>([]);

  useEffect(() => {
    const savedData = localStorage.getItem('pageData_home');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setSections(parsedData);
        console.log('Loaded updated data from localStorage');
      } catch (error) {
        console.error('Error parsing localStorage data:', error);
        setSections(pagesData.home?.sections || []);
      }
    } else {
      setSections(pagesData.home?.sections || []);
    }
  }, []);

  const sectionComponents: Record<string, React.ComponentType<any>> = {
    HeroSection,
    VisionMissionSection,
    AboutPreview,
    ServicesSection,
    ServicesGridSection,
    ServicesCTASection,
    ImpactSection,
    ProjectsSection,
    WhyChooseUs,
    NewsSection,
    ContactCallout,
    MapSection,
  };

  return (
    <div className={`min-h-screen ${language === 'ar' ? 'font-cairo' : 'font-montserrat'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      {sections.map((section, idx) => {
        const SectionComponent = sectionComponents[section.type];
        if (!SectionComponent) return null;
        return <SectionComponent key={idx} language={language} {...section.props} />;
      })}
    </div>
  );
};

export default Home; 